import { loadScript } from '../../../utils';
import {
  CLEARPAY_SCRIPT_LOADING,
  CLEARPAY_SCRIPT_LOADED,
  CLEARPAY_SCRIPT_FAILED,
  CLEARPAY_MESSAGE_SCRIPT_LOADED,
  CLEARPAY_STUBS_MODAL_OPEN,
  CLEARPAY_STUBS_MODAL_CLOSE,
  CLEARPAY_SAVE_CARD,
  CLEARPAY_ERROR,
  CLEARPAY_CANCEL,
  CLEARPAY_ENABLED_STATUS,
} from '../../../constants/actionConstants';
import { reportErrorToNewRelic } from '../../../utils/logging/logging-utils';
import {
  validateBillingAddress,
  validatePostcodeSearch,
} from './paymentActions';

export const loadClearpayScript = () => async (dispatch, getState) => {
  const state = getState();

  if (state.payment.clearpayScriptLoading) return;

  if (state.payment.clearpayScriptLoaded) return;

  await dispatch({ type: CLEARPAY_SCRIPT_LOADING });

  const onErrorCallback = () => {
    dispatch(reportErrorToNewRelic({ error: Error(), errorDescription: 'Clearpay script error' }));
    dispatch({ type: CLEARPAY_SCRIPT_FAILED });
  };

  const buttonRenderTimeout = setTimeout(() => {
    const spinner = document.querySelector('[data-testid="clearpay-spinner-container"]');
    if (spinner) {
      onErrorCallback();
    }
  }, 10000);

  const marketplaceScriptUrl = window.env.CLEARPAY_MESSAGE_SCRIPT_URL;
  loadScript({
    url: marketplaceScriptUrl,
    onSuccessCallback: () => {
      clearTimeout(buttonRenderTimeout);
      dispatch({ type: CLEARPAY_MESSAGE_SCRIPT_LOADED });
    },
    onErrorCallback: () => {
      clearTimeout(buttonRenderTimeout);
      onErrorCallback();
    },
  })();

  const buttonScriptUrl = window.env.CLEARPAY_BUTTON_SCRIPT_URL;
  loadScript({
    url: buttonScriptUrl,
    onSuccessCallback: () => {
      clearTimeout(buttonRenderTimeout);
      dispatch({ type: CLEARPAY_SCRIPT_LOADED });
    },
    onErrorCallback: () => {
      clearTimeout(buttonRenderTimeout);
      onErrorCallback();
    },
  })();
};

export const openClearpayStubsModal = () => ({
  type: CLEARPAY_STUBS_MODAL_OPEN,
});

export const closeClearpayStubsModal = () => ({
  type: CLEARPAY_STUBS_MODAL_CLOSE,
});

export const saveVirtualCard = virtualCard => ({
  type: CLEARPAY_SAVE_CARD,
  virtualCard,
});

export const handleClearpayError = error => ({
  type: CLEARPAY_ERROR,
  error,
});

export const handleClearpayCancel = () => ({
  type: CLEARPAY_CANCEL,
});

export const handleClearpayFormErrors = () => async (dispatch) => {
  dispatch(validateBillingAddress());
  dispatch(validatePostcodeSearch());
};

export const setClearpayEnabledStatus = enabled => ({
  type: CLEARPAY_ENABLED_STATUS,
  enabled,
});
